import React, { useCallback, useMemo, useRef, useState } from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import {
  Container, SliderRelated,
} from '@uncinc/uncinc-react-kitchen-sink';

import DefaultItem from './DefaultItem';

const DEFAULT_SLIDER_PROPS = {
  draggable: true,
  swipe: true,
  centerMode: false,
  arrows: false,
  autoplay: false,
  infinite: false,
  slidesToScroll: 1,
  slidesToShow: 1,
  lazyload: true,
  initialSlide: 0,
  variableWidth: true,
};

import './style.scss';

const Slider = (props) => {
  const {
    items,
    sliderProps,
    className,
    RenderItem = DefaultItem,
    renderItemProps,
    lazyload = true,
  } = props;

  const sliderRef = useRef(null);
  const [canGoToNext, setCanGoToNext] = useState(true);
  const [canGoToPrev, setCanGoToPrev] = useState(false);

  const previousSlide = () => sliderRef.current.slickPrev();
  const nextSlide = () => sliderRef.current.slickNext();
  const classNames = c('Slider', className);

  const beforeChange = useCallback((current, next) => {
    setCanGoToNext(next !== (items.size - 1));
    setCanGoToPrev(next !== 0);
  }, [items.size]);

  const usableSliderProps = useMemo(() => {
    const defaultProps = { ...DEFAULT_SLIDER_PROPS, beforeChange: beforeChange };

    return {
      ...defaultProps,
      ...(sliderProps && Object.keys(sliderProps).length > 0 ? sliderProps : {}),
    };
  }, [beforeChange, sliderProps]);

  return (
    <div className={classNames}>
      <div className="Slider__content">
        <SliderRelated
          sliderRef={sliderRef}
          {...usableSliderProps}
        >
          {items && items.map((item) => {
            const uuid = item.getIn(['entity', 'uuid', 0, 'value'], '');
            const showImage = item.getIn(['entity', 'field_image'], Immutable.List()).size > 0;

            return (
              <RenderItem
                {...renderItemProps}
                key={uuid}
                item={item}
                showImage={showImage}
                lazyload={lazyload}
              />
            );
          })}
        </SliderRelated>
      </div>

      <div className="Slider__container">
        <Container>
          <div className="Slider__navigation">
            <div className="Slider__navigation__actions">
              <div className="Slider__navigation__actions__scrollbar" />
              <div className="Slider__navigation__actions__icon left">
                <div
                  onClick={previousSlide}
                  className={`hover-icon icon-before icon-arrow-left-filled icon-variant-${canGoToPrev ? '0' : '1'}`}
                />
              </div>
              <div className="Slider__navigation__actions__icon right">
                <div
                  onClick={nextSlide}
                  className={`hover-icon icon-before icon-arrow-right-filled icon-variant-${canGoToNext ? '0' : '1'}`}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Slider;
